import React, { useEffect, useState } from 'react';

export default function IdleMount({ children, timeout = 2000 }) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const id = window.requestIdleCallback
      ? window.requestIdleCallback(() => setReady(true), { timeout })
      : window.setTimeout(() => setReady(true), Math.min(timeout, 500));
    return () => window.cancelIdleCallback ? window.cancelIdleCallback(id) : window.clearTimeout(id);
  }, [timeout]);
  return ready ? children : null;
}
